export default {
  name: 'container',
  // template: '<div :class="container_class"><h1>Container showing: {{ route }}</h1><h2>Exhibit ID: {{ exhibitid }}</h2><router-view></router-view></div>',
  template: '<keep-alive :include="[\'allmedia\']"><router-view></router-view></keep-alive>',
  computed: {
    routepath () {
      return this.$route.path
    }
  },
  props: {
    container_class: String,
    exhibitslug: String
  }
}
